import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@opentelemetry+api@1.9.0_@playwright+test@1.63.0_@types+node@22.20.2_react_553cbaca1ae44cc8ed8c1786112d26fa/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@opentelemetry+api@1.9.0_@playwright+test@1.63.0_@types+node@22.20.2_react_553cbaca1ae44cc8ed8c1786112d26fa/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@opentelemetry+api@1.9.0_@playwright+test@1.63.0_@types+node@22.20.2_react_553cbaca1ae44cc8ed8c1786112d26fa/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieButton"] */ "/app/src/components/CookieButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMPageView"] */ "/app/src/components/GTMPageView/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMScrollDepth"] */ "/app/src/components/GTMScrollDepth/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/app/src/components/ScrollToTop/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTopButton"] */ "/app/src/components/ScrollToTopButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/ScrollIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterForm"] */ "/app/src/Footer/NewsletterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClient"] */ "/app/src/Header/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentManagerClient"] */ "/app/src/providers/ConsentManagerClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderThemeProvider"] */ "/app/src/providers/HeaderTheme/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LenisProvider"] */ "/app/src/providers/LenisProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/providers/Theme/index.tsx");
